<template>
	<div class="single_question">
		<div class="question_title">
			<span>{{questionData.sectionName === undefined ? "" : questionData.sectionName}}</span>
			<span>({{questionData.sectionPrompt+" 本题"+questionData.score+"分。"}})</span>
		</div>
		<div class="question_cont">
			<div class="title" :style="'height:'+height">
				<p class="q_num">第{{questionData.orderSort+1}}题</p>
				<div v-if="questionData.questionContent" class=" editorShowArea ql-editor title_one" v-html="questionData.questionContent">
				</div>
				<h1 style="overflow: auto;" class=" editorShowArea ql-editor" v-html="questionData.questionDto.questionContent"></h1>
			</div>
			<div class="single_cont" :style="'height:'+height">
				<div class="single_item" v-for="(data,index) in questionData.questionDto.childQuestions" :key="index">
					<div class="num_title">
						<span>{{index+1}}.</span>
						<div class="test-title editorShowArea ql-editor" v-html="data.questionContent"></div>
					</div>
					<div class="testCont" v-for="(v,i) in data.items" :key="i">
							<el-checkbox @change="save(data,index)" class="single_radio" v-model="checked[index][i]">{{null}}</el-checkbox>
							<span style="float: left;margin-top:15px;" class="single_title editorShowArea ql-editor" v-html="v.itemKey"></span>
							<p class="single_title  editorShowArea ql-editor" v-html="v.itemValue"></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		moduleId
	} from "../../../../../store/modules/exam";
	import {
		mapState,
		mapMutations,
		mapActions,
		mapGetters
	} from 'vuex';
	export default {
		name: "more",
		data() {
			return {
				checked: [[false,false,false,false], [false,false,false,false], [false,false,false,false], [false,false,false,false],[false,false,false,false], [false,false,false,false], [false,false,false,false], [false,false,false,false]],
				height: window.innerHeight - 260 + 'px'
			};
		},
		computed: {
			...mapState(moduleId, {
				questionData: state => state.questionData,
				paperData: state => state.paperData,
				preAnswer: state => state.preAnswer,
				questionList: state => state.questionList,
			}),
		},
		watch: {
			questionList(newVal) {
				let that = this;
				this.checked = [[false,false,false,false],[false,false,false,false],[false,false,false,false],[false,false,false,false],[false,false,false,false],[false,false,false,false],[false,false,false,false],[false,false,false,false]]
				this.newArr = []
				newVal.forEach(item=>{
					this.newArr.push(item.answer.split(","))
				})
				this.newArr.forEach((item,index) => {
					if(item.length){
						item.forEach(val=>{
							if (val === "A") {
								that.$set(that.checked[index], 0, true);
							} else if (val === "B") {
								that.$set(that.checked[index], 1, true);
							} else if (val === "C") {
								that.$set(that.checked[index], 2, true);
							} else if (val === "D") {
								that.$set(that.checked[index], 3, true);
							} else if (val === "E") {
								that.$set(that.checked[index], 4, true);
							} else if (val === "F") {
								that.$set(that.checked[index], 5, true);
							} else if (val === "G") {
								that.$set(that.checked[index], 6, true);
							}
						})
					}
				})
			}
		},
		methods: {
			...mapActions(moduleId, ['saveAnswerNew']),
			save(data,ind) {
				let str = '';
				this.checked.forEach((item, index) => {
					console.log(item);
					if(ind == index){
						item.forEach((v,i)=>{
							if (v === true && i === 0) {
								str += 'A,';
							} else if (v === true && i === 1) {
								str += 'B,';
							} else if (v === true && i === 2) {
								str += 'C,';
							} else if (v === true && i === 3) {
								str += 'D,';
							} else if (v === true && i === 4) {
								str += 'E,';
							} else if (v === true && i === 5) {
								str += 'F,';
							} else if (v === true && i === 6) {
								str += 'G,';
							}
						})
					}
				});
				let obj = {
					"examPaperId": this.paperData.examPaperId,
					"subjectId": localStorage.getItem("subjectId"),
					"classId": this.$route.query.classId,
					"courseId": this.$route.query.id,
					"paperCode": this.$route.query.paperCode,
					"paperId": this.$route.query.paperId,
					"questionId": data.id,
					"questionType": 2,
					"version": 1,
					"userAnswer": str.substring(0, str.length - 1),
					"score": data.score,
					"questionStatus": 0,
					"useTime": "23",
					"type": this.$route.query.type
				};
				console.log(obj)
				this.saveAnswerNew(obj);
			},
			arrTrans(arr) { // 一维数组转换为二维数组
			  const iconsArr = []; // 声明数组
			  arr.forEach((item, index) => {
			    iconsArr[index].push(item);
			  });
			  return iconsArr;
			}
		},
		mounted() {
			console.log(this.questionData.questionDto)
		},
	}
</script>

<style lang="scss" scoped>
	.single_question {
		.question_cont {
			display: flex;
			justify-content: space-between;
			.single_cont {
				flex: 50%;
				margin-top: 30px;
				overflow: auto;
			}
			.title {
				flex: 50%;
				.q_num {
					color: #000000;
					font-size: 16px;
					font-weight: 600;
					margin-top: 14px;
					margin-left: 28px;
				}
			}
		}
		.question_title {
			width: 97%;
			margin-left: 30px;
			padding-top: 30px;
			padding-bottom: 30px;
			border-bottom: 1px solid #BBCEF6;

			span:nth-child(1) {
				font-size: 18px;
				font-weight: bold;
			}

			span:nth-child(2) {
				font-size: 12px;
				font-weight: 500;
				margin-left: 12px;
			}
		}

		.title {
			.title_one {
				border-bottom: 1px dashed black;
				width: 95%;
				margin: auto;
			}

			.ql-editor {
				max-width: 94%;
				overflow: auto !important;
				margin: auto;
				border-right: 8px solid #A1B5FA;
				font-size: 16px;
			}

			/deep/ .ql-editor img {
				max-width: 100% !important;
			}
		}

		.single_item {
			margin-left: 50px;
			display: block;
			margin-bottom: 30px;
			.num_title {
				display: flex;
				justify-content: start;
				span {
					display: inline-block;
					margin-right: 10px;
				}
				.test-title {
					line-height: 24px;
				}
			}
			.testCont {
			}
			.single_radio {
				float: left;
				margin-top: 12px;
				margin-right: 5px !important;
			}

			.single_title {
				display: inline-block;
				padding-top: 0;
				padding-bottom: 0;
				margin-top: 9px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testSumulationComponentNew/uncertain.vue